import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { Container, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Form, FormGroup, FormField, Input, Select, TextArea, Button, Message, MessageHeader, Icon } from 'semantic-ui-react'

const rankOptions = [
    { key: 'admin', text: 'Admin', value: 'Admin' },
    { key: 'staff', text: 'Staff', value: 'Staff' }
]

const CreateAdmin = ({ goBack }) => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [rank, setRank] = useState('')
    const [remarks, setRemarks] = useState('')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const user = useSelector(state => state.userAdmin)

    const renderRankField = () => {
        if (rank && rank.toLowerCase() === 'superadmin') {
            return <FormField control={Input} readOnly label="Rank" name="rank" value={rank} placeholder="" inverted className="dark-theme-input"/>
        }
        return <FormField control={Select} label="Rank" name="rank" value={rank} options={rankOptions} placeholder="Select rank..." onChange={(e, { value }) => handleChangeRankDropDown(value)} inverted />
    }

    const renderForm = () => {
        return <Container>
                <Form inverted>
                    <FormGroup widths="equal">
                        <FormField control={Input} label="Name" name="name" value={name} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                        {renderRankField()}
                    </FormGroup>
                    <FormGroup widths="equal">
                        <FormField control={Input} label="Email" name="email" value={email} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                        <FormField control={Input} label="Password" name="password" value={password} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                    </FormGroup>
                    <FormField control={TextArea} rows="2" label="Remarks" name="remarks" value={remarks} placeholder="" onChange={handleChangeField} inverted className="dark-theme-textarea-field"/>
                </Form>
            </Container>
    }

    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'name') setName(value)
        if (name === 'email') setEmail(value)
        if (name === 'password') setPassword(value)
        if (name === 'remarks') setRemarks(value)
        setShowSuccessMessage(false)
    }

    const handleChangeRankDropDown = value => {
        setRank(value)
        setShowSuccessMessage(false)
    }

    const handleSaveClicked = async () => {
        const dict = { createdBy: user.name, createdAt: Date(), name, email, rank, password, remarks }
        await axios.post('/api/user', dict)
        .then(() => {
            goBack()
        })
        .catch(err => {
            console.log(`create user failed with error: ${err}`)
            alert(`Failure creating user, please try again. Error: ${err}`)
        })
    }

    const handleCancelClicked = () => {
        goBack()
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', padding: '20px' }}>
            <Breadcrumb inverted style={{ marginTop: 20, marginBottom: 20 }} size="large">
                <BreadcrumbSection onClick={handleCancelClicked} style={{ color: 'white', cursor: 'pointer' }}>
                    Users
                </BreadcrumbSection>
                <BreadcrumbDivider color='teal' icon="right chevron" />
                <BreadcrumbSection active style={{ color: 'white' }}>Create New User</BreadcrumbSection>
            </Breadcrumb>
            {renderForm()}
            {showSuccessMessage ? (
                <Message inverted success>
                    <MessageHeader>Changes saved</MessageHeader>
                </Message>
            ) : null}
            <Button inverted color='teal' style={{ marginTop: 25, marginRight: 15 }} onClick={handleSaveClicked}><Icon inverted color='teal' name='check' />Create User</Button>
            <Button inverted onClick={handleCancelClicked}><Icon inverted name="reply" />Back</Button>
        </Container>
    )
}

export default CreateAdmin